import { z } from 'zod';
import { BaseEntity, WithBaseEntitySchema } from '../../../../models/src';
import { EnumSchema, Executor, FromSchema } from '../../../common/src';
import { Seller } from '../../../sellers/src';
import { ErpSyncMode } from './erp-sync-mode.enum';
import { ErpSyncStatus } from './erp-sync-status.enum';
import { ErpSyncSummary, ErpSyncSummarySchema } from './summary/erp-sync-summary.dto';

export const ErpSyncSchema = WithBaseEntitySchema(
    z.object({
        status: EnumSchema(ErpSyncStatus),
        lastSyncAt: z.date().optional(),
        connection: z.string(),
        summary: ErpSyncSummarySchema.optional(),
        mode: EnumSchema(ErpSyncMode).optional(),
        message: z.string().optional(),
    }),
).strict();

export class ErpSync extends FromSchema(ErpSyncSchema) implements BaseEntity {
    id: string;
    status: ErpSyncStatus;
    connection: string;
    lastSyncAt?: Date;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    createdBy?: Executor;
    mode?: ErpSyncMode;
    summary?: ErpSyncSummary;
    message?: string;
    seller?: string | Seller;
    tenantId: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
